import React from 'react';
import Link from 'gatsby-link';

import styled from 'styled-components';

// Components
import Card from '../../components/Card';

const PageWrapper = styled.section``;

const StandaloneCardPage = () => {

  return (
    <PageWrapper>
      <h1>The Card Component</h1>
      <p>This component is baked out into static HTML. It was a stateless functional React component, which is just a pure render function, and we know the props at build time.</p>
      <Card
        title='Vitamin C'
        description='Lorem ipsum dolor sit amet consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        friendlytitle='Boosts your immune system'
        colors={['rgba(0, 0, 0, 0.05)']} />
    </PageWrapper>
  );
};

export default StandaloneCardPage;



// WEBPACK FOOTER //
// ./src/pages/jamstack/card.js